import { Component, ElementRef, OnInit, ViewChild, input, output } from '@angular/core';
import { DropdownService } from 'src/app/project/components/dropdown/dropdown-service/dropdown.service';
import { EIconPath } from '../../../../shared/enums/icons.enum';
import { CustomFieldMultiListSelectDropdownComponent } from '../../custom-field-multi-list-select-dropdown/custom-field-multi-list-select-dropdown.component';
import {
  generateMultiListValueFromSelectedIds,
  keepOnlyTopLevelSelected,
} from '../../custom-field-multi-list-select/custom-field-multi-list-select-utils';
import { EIntegrationStatus, TCustomField } from '../../custom-fields.model';
import { TBulkCustomFields, TBulkCustomFieldsExtended } from '../bulk-custom-fields.model';

@Component({
  selector: 'pp-bulk-field-multi-list',
  templateUrl: './bulk-field-multi-list.component.html',
  styleUrls: ['../bulk-custom-fields-modal.component.scss'],
  standalone: false,
})
export class BulkFieldMultiListComponent implements OnInit {
  ppCustomField = input<TCustomField>(undefined);
  ppCustomFields = input<TBulkCustomFields<string>>(undefined);
  ppFieldId = input<string>(undefined);
  ppCustomFieldsExtended = input<TBulkCustomFieldsExtended<string>>(undefined);
  ppDisabled = input<boolean>(false);
  fieldValue = '';

  ppCustomFieldsExtendedChange = output<TBulkCustomFieldsExtended>();
  ppCustomFieldsChange = output<TBulkCustomFields>();

  @ViewChild('pointFieldsList') pointFieldsListElement: ElementRef;

  EIconPath = EIconPath;
  EIntegrationStatus = EIntegrationStatus;
  volyIntegrationActive = '';
  updating = false;
  error = false;
  focused = false;
  dropdownVisible = false;
  disabled = false;

  constructor(private dropdownService: DropdownService) {}

  ngOnChanges(): void {
    this.disabled = this.ppDisabled() || this.ppCustomField()?.lockedValue;
  }

  ngOnInit(): void {
    this.volyIntegrationActive = this.ppCustomField().volyIntegrationActive;
  }

  clearCustomField(field: TCustomField): void {
    const customFields = this.ppCustomFields();
    const customFieldsExtended = this.ppCustomFieldsExtended();
    customFields[field.id] = undefined;
    customFieldsExtended[field.id] = {};

    this.ppCustomFieldsChange.emit(customFields);
    this.ppCustomFieldsExtendedChange.emit(customFieldsExtended);
  }

  showList(): void {
    if (this.ppDisabled()) {
      return;
    }

    const customField = this.ppCustomField();

    if (customField.lockedValue) {
      return;
    }

    this.focused = true;

    const inputElement = this.pointFieldsListElement.nativeElement.getBoundingClientRect();

    this.dropdownService.setData({
      field: customField,
      selected: [],
    });

    this.dropdownService.showDropdown(
      `cbulkMultiList${this.ppFieldId()}`,
      CustomFieldMultiListSelectDropdownComponent,
      {
        callback: (item) => {
          this.successCallback(item);
        },
        suppressScrollbar: true,
        width: `${Math.max(225, inputElement.width)}px`,
      },
    );

    this.dropdownVisible = true;
  }

  selectCustomField(selectedIds: string[]): void {
    const topLevelItems = keepOnlyTopLevelSelected(this.ppCustomField().subList, selectedIds);
    const sort = generateMultiListValueFromSelectedIds(this.ppCustomField().subList, selectedIds);

    const sortedVals = this.sortValues(sort);
    const customFields = this.ppCustomFields();
    const customFieldsExtended = this.ppCustomFieldsExtended();

    this.fieldValue = sortedVals;
    customFields[this.ppFieldId()] = this.fieldValue;

    customFieldsExtended[this.ppFieldId()] = {
      idOfChosenElements: topLevelItems,
      value: this.fieldValue,
      label: this.ppCustomField().label,
      type: this.ppCustomField().type,
    };

    this.ppCustomFieldsExtendedChange.emit(customFieldsExtended);
    this.ppCustomFieldsChange.emit(customFields);
  }

  sortValues(vals: string): string {
    const unsortedVals = vals.split(', ');

    return unsortedVals.sort().join(', ');
  }

  private successCallback(itemIds: string[]): void {
    if (itemIds) {
      this.selectCustomField(itemIds);
    }

    this.ppCustomFieldsChange.emit(this.ppCustomFields());
    this.ppCustomFieldsExtendedChange.emit(this.ppCustomFieldsExtended());
  }
}
